module.exports = __webpack_public_path__ + "img/d39c084.png";